// Mock 数据 - 模拟后端返回数据

export const mockSkills = [
  {
    id: 'hot-search',
    title: '热点信息查询',
    description: '按地域、时间、平台查询热榜 Top10，快速获取热点事件，支持多平台数据聚合',
    features: ['实时数据', '多平台', 'Top10'],
    iconType: 'hot',
    active: true,
    version: 'v1.2.0'
  },
  {
    id: 'social-search',
    title: '社交平台查询',
    description: '多条件检索微信、微博、抖音等内容，支持关键词、时间范围、账号筛选',
    features: ['高级筛选', '社交舆情', '多平台'],
    iconType: 'social',
    active: true,
    version: 'v1.1.5'
  },
  {
    id: 'report',
    title: '舆情报告生成',
    description: '自动生成结构化舆情报告，包含情感分析、趋势预测、风险提示',
    features: ['AI 生成', '多格式', '趋势分析'],
    iconType: 'report',
    active: true,
    version: 'v2.0.1'
  },
  {
    id: 'more',
    title: '更多技能',
    description: '智能语义搜索、情感分析、自定义创建等更多专业技能即将上线',
    features: ['开发中', '敬请期待'],
    iconType: 'coming',
    active: false
  }
]

export const mockSkillDetail = {
  id: 'hot-search',
  title: '热点信息查询',
  description: '按地域、时间、平台查询热榜 Top10，快速获取热点事件，支持多平台数据聚合',
  features: ['实时数据', '多平台', 'Top10'],
  iconType: 'hot',
  active: true,
  version: 'v1.2.0'
}

export const mockFiles = [
  { name: 'hotspot_query.py', desc: '主程序文件 · 12.5 KB' },
  { name: 'config.yaml', desc: '配置文件 · 2.3 KB' },
  { name: 'README.md', desc: '说明文档 · 5.8 KB' }
]

export const mockChangelogs = [
  {
    version: 'v2.3.0',
    tag: 'new',
    tagLabel: 'NEW',
    date: '2026-03-22',
    changes: [
      '新增知乎热榜数据支持',
      '优化数据更新频率，提升至 5 分钟/次',
      '修复部分地区数据获取失败的问题'
    ]
  },
  {
    version: 'v2.2.0',
    tag: 'improve',
    tagLabel: 'IMPROVE',
    date: '2026-03-10',
    changes: [
      '增加地域筛选功能，支持省份级别筛选',
      '优化返回数据结构，增加热度趋势字段',
      '提升 API 响应速度 30%'
    ]
  },
  {
    version: 'v2.1.0',
    tag: 'fix',
    tagLabel: 'FIX',
    date: '2026-02-25',
    changes: ['修复抖音平台数据解析错误', '修复高峰期并发请求超时问题', '优化错误提示文案']
  },
  {
    version: 'v2.0.0',
    tag: 'new',
    tagLabel: 'NEW',
    date: '2026-02-10',
    changes: [
      '重构数据抓取模块，支持更多平台',
      '新增实时数据推送功能',
      'API 接口升级，支持批量查询'
    ]
  }
]

export const mockUserProfile = {
  id: 1,
  name: 'Leo',
  phone: '138****8888',
  email: 'leo@example.com',
  level: '高级用户'
}

export const mockUserStats = {
  installedSkills: 3,
  monthlyCalls: 1256,
  remainingQuota: 8744
}

export const mockApikey = 'sk-a8f3b2c1d4e5f6g7h8i9j0k1l2m3n4o5'

export const mockInstalledSkills = [
  {
    id: 1,
    skillName: '互联网内容洞察',
    skillNameEn: 'social-platform-query',
    description: '面向全域网络信息监测与情报分析场景...',
    domainTags: '信息查询',
    customTags: '社交舆情,多平台',
    iconType: 'social',
    originalPath: '/social-platform-query',
    monthlyCallCount: 128
  },
  {
    id: 2,
    skillName: '热点信息查询',
    skillNameEn: 'hot-search',
    description: '按地域、时间、平台查询热榜 Top10',
    domainTags: '信息查询',
    customTags: '热榜,多平台',
    iconType: 'hot',
    originalPath: '/hot-search',
    monthlyCallCount: 523
  },
  {
    id: 3,
    skillName: '舆情报告生成',
    skillNameEn: 'report',
    description: '自动生成结构化舆情分析报告',
    domainTags: '报告生成',
    customTags: 'AI生成,舆情',
    iconType: 'report',
    originalPath: '/report',
    monthlyCallCount: 244
  }
]

export const mockUsageRecords = [
  {
    id: 1,
    skillName: '热点信息查询',
    requestTime: '2026-04-02T15:30:00',
    skillNameEn: 'social-platform-query'
  },
  {
    id: 2,
    skillName: '社交平台查询',
    requestTime: '2026-04-02T16:45:00',
    skillNameEn: 'social-platform-query1'
  }
]

export const mockskillOverview = {
  totalInstalledSkills: 5,
  newInstalledSkillsThisMonth: 2,
  callsThisMonth: 1580,
  callsLastMonth: 1200,
  growthPercentage: 31.67
}
